// import React, { useState } from "react";
// import "./WhatsNew.css";
// import { whatsNewData } from "./data";

// const ITEMS_PER_SLIDE = 5;

// export default function WhatsNew() {
//     const [currentIndex, setCurrentIndex] = useState(0);

//     const totalSlides =
//   whatsNewData.length - ITEMS_PER_SLIDE + 1;


//     const handleDotClick = (index) => {
//         setCurrentIndex(index);
//     };

//     const start = currentIndex * ITEMS_PER_SLIDE;
//    const visibleItems = whatsNewData.slice(
//   currentIndex,
//   currentIndex + ITEMS_PER_SLIDE
// );


//     return (
//         <section className="whatsnew-section">
//             <h2 className="whatsnew-heading">Whats' New</h2>
//             <p className="whatsnew-sub">
//                 From intuitive technology to a commanding new design, the all-new Hector brings together innovations that leave a lasting impression - Designed to Surprise. 
//             </p>

//             <div className="carousel">
//                 {visibleItems.map((item) => (
//                     <div key={item.id} className="card">
//                         <div className="image-wrapper">
//                             <img src={item.image} alt={item.title} />
//                             <div className="overlay">
//                                 <div className="overlay-text">
//                                     <span className="red-line"></span>
//                                     <h4>{item.title}</h4>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div className="dots">
//                 {Array.from({ length: totalSlides }).map((_, index) => (
//                     <span
//                         key={index}
//                         className={`dot ${currentIndex === index ? "active" : ""
//                             }`}
//                         onClick={() => handleDotClick(index)}
//                     />
//                 ))}
//             </div>
//         </section>
//     );
// }









import React, { useState, useEffect } from "react";
import "./WhatsNew.css";
import { whatsNewData } from "./data";

export default function WhatsNew() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(5);

  // Screen width detect karne ke liye
  useEffect(() => {
    const updateItemsPerSlide = () => {
      if (window.innerWidth <= 768) {
        setItemsPerSlide(1); // Mobile
      } else if (window.innerWidth <= 1024) {
        setItemsPerSlide(3); // Tablet
      } else {
        setItemsPerSlide(5); // Desktop
      }
    };

    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);

    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  const totalSlides =
    whatsNewData.length - itemsPerSlide + 1;

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  const visibleItems = whatsNewData.slice(
    currentIndex,
    currentIndex + itemsPerSlide
  );

  return (
    <section className="whatsnew-section">
      <h2 className="whatsnew-heading">Whats' New</h2>
      <p className="whatsnew-sub">
        From intuitive technology to a commanding new design, the all-new
        Hector brings together innovations that leave a lasting impression -
        Designed to Surprise.
      </p>

      <div className="carousel">
        {visibleItems.map((item) => (
          <div key={item.id} className="card">
            <div className="image-wrapper">
              <img src={item.image} alt={item.title} />
              <div className="overlay">
                <div className="overlay-text">
                  <span className="red-line"></span>
                  <h4>{item.title}</h4>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="dots">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </section>
  );
}
